import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const FAQ_ITEMS = [
  {
    q: "Where is The Bar Colac located?",
    a: "The Bar is in the heart of Colac, Victoria, at 27 Murray Street, Colac VIC 3250 — easy walking distance from the main shops and Lake Colac.",
  },
  {
    q: "What nights is The Bar Colac open?",
    a: "We're open every Friday and Saturday night from 8pm until late — see the Upcoming Events list for what's on when you visit.",
  },
  {
    q: "Does The Bar Colac have live music?",
    a: "Yes — The Bar Colac hosts live music most weekends, featuring local Colac bands, Geelong touring acts and the occasional out-of-state guest. The lineup rotates, so check the Upcoming Events list for the next gig.",
  },
  {
    q: "Does The Bar Colac host karaoke?",
    a: "Yes — karaoke is a staple at The Bar Colac. Nights rotate week to week alongside live music, so keep an eye on the Upcoming Events list to see when the mic's up next. Walk in, grab a drink and put your name down — no booking required.",
  },
  {
    q: "Can I hire The Bar Colac for a private event?",
    a: "Absolutely. The Bar is available for private hire for birthdays, work parties, engagements, reunions and any other excuse to take over a Colac pub for the night. Email thebarcolac@gmail.com or message us on Facebook to enquire.",
  },
  {
    q: "Is there a cover charge or entry fee?",
    a: "Entry is free for karaoke nights and most live music nights at The Bar Colac. A small cover may apply on special touring acts — we'll always note this on the Facebook event page.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-semibold">
            / FAQ
          </span>
          <h2 className="font-display text-5xl sm:text-6xl text-[#FDFBF7] uppercase mt-4 leading-[0.9]">
            Got <span className="text-[#F5A623]">questions?</span>
          </h2>
          <p className="mt-4 text-[#FDFBF7]/65 max-w-xl mx-auto">
            Everything you need to know before your first night at the best
            bar in Colac.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5 }}
        >
          <Accordion
            type="single"
            collapsible
            className="border border-white/10"
            data-testid="faq-accordion"
          >
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-white/10 last:border-b-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="px-6 py-5 text-left font-display text-lg sm:text-xl uppercase tracking-wide text-[#FDFBF7] hover:text-[#F5A623] hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 text-[#FDFBF7]/75 text-base leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
